import { SelectedSystemType } from 'data/types';
import { CompatibilityPairRef } from 'utils/compatibility-bundle-types';

type BundleFields = {
  designConfigurationUniqueId?: unknown;
  compatibilityPairs?: unknown;
};

export function readDesignConfigurationUniqueId(
  system: object | null | undefined
): string | null {
  const value = (system as BundleFields | null | undefined)
    ?.designConfigurationUniqueId;
  return typeof value === 'string' && value.length > 0 ? value : null;
}

export function readCompatibilityPairs(
  system: object | null | undefined
): CompatibilityPairRef[] {
  const value = (system as BundleFields | null | undefined)?.compatibilityPairs;
  return Array.isArray(value) ? (value as CompatibilityPairRef[]) : [];
}

export function isDuctedBundleSystem(
  system: object | null | undefined
): boolean {
  return readCompatibilityPairs(system).length > 1;
}

export function stampCompatibilityBundleFields(
  system: SelectedSystemType,
  fields: {
    designConfigurationUniqueId: string | null;
    compatibilityPairs: CompatibilityPairRef[];
  }
): void {
  const target = system as SelectedSystemType & BundleFields;
  if (fields.designConfigurationUniqueId) {
    target.designConfigurationUniqueId = fields.designConfigurationUniqueId;
  }
  target.compatibilityPairs = fields.compatibilityPairs;
}
